<template>
  <section class="aura-features">
    <div class="container">
      <!-- Section header -->
      <div class="features-header">
        <p class="section-eyebrow">{{ $t('whyChooseUs') }}</p>
        <h2 class="section-title">{{ $t('Why') }}</h2>
        <p class="section-sub">{{ $t('WhyReason') }}</p>
      </div>

      <!-- Feature cards -->
      <div class="features-grid">
        <div class="feature-card">
          <div class="feature-icon-wrap icon-amber">
            <span class="ti-vector"></span>
          </div>
          <h3 class="feature-title">{{ $t('AI') }}</h3>
          <p class="feature-desc">{{ $t('AIReason') }}</p>
          <router-link to="/about" class="feature-link">
            {{ $t('AboutUs') }}
            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 10h12M11 5l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
        </div>

        <div class="feature-card">
          <div class="feature-icon-wrap icon-slate">
            <span class="ti-id-badge"></span>
          </div>
          <h3 class="feature-title">{{ $t('domesticHelper') }}</h3>
          <p class="feature-desc">{{ $t('domesticHelperReason') }}</p>
          <router-link to="/services" class="feature-link">
            {{ $t('OurServices') }}
            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 10h12M11 5l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
        </div>

        <div class="feature-card">
          <div class="feature-icon-wrap icon-emerald">
            <span class="ti-check"></span>
          </div>
          <h3 class="feature-title">{{ $t('bestfit') }}</h3>
          <p class="feature-desc">{{ $t('bestfitReason') }}</p>
          <router-link to="/matching" class="feature-link">
            {{ $t('MatchNow') }}
            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 10h12M11 5l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Promo",
};
</script>

<style scoped>
.aura-features {
  background: #FDFCFB;
  padding: 96px 0;
}

/* ── Section header ── */
.features-header {
  text-align: center;
  max-width: 640px;
  margin: 0 auto 64px;
}
.section-eyebrow {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #C93380;
  margin-bottom: 12px;
}
.section-title {
  font-family: 'Playfair Display', Georgia, serif;
  font-size: clamp(26px, 3.5vw, 38px);
  font-weight: 500;
  color: #0A7A76;
  line-height: 1.2;
  margin: 0 0 16px;
}
.section-sub {
  font-size: 16px;
  color: #64748b;
  line-height: 1.75;
  font-weight: 300;
  margin: 0;
}

/* ── Cards grid ── */
.features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.feature-card {
  background: #fff;
  border: 1px solid #f1f5f9;
  border-radius: 20px;
  padding: 36px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04);
  transition: box-shadow 0.25s, transform 0.25s;
}
.feature-card:hover {
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.1);
  transform: translateY(-4px);
}

/* ── Icon ── */
.feature-icon-wrap {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.icon-amber  { background: #E4F6F5; color: #C93380; }
.icon-slate  { background: #f1f5f9; color: #475569; }
.icon-emerald { background: #E4F6F5; color: #45C9C2; }

.feature-title {
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 18px;
  font-weight: 600;
  color: #0A7A76;
  margin: 0;
  line-height: 1.3;
}
.feature-desc {
  font-size: 14px;
  color: #64748b;
  line-height: 1.7;
  margin: 0;
  flex: 1;
}
.feature-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #0A7A76;
  text-decoration: none !important;
  transition: gap 0.2s;
  margin-top: 8px;
}
.feature-link svg {
  width: 16px;
  height: 16px;
  transition: transform 0.2s;
}
.feature-link:hover { color: #475569; }
.feature-link:hover svg { transform: translateX(4px); }

@media (max-width: 900px) {
  .features-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 600px) {
  .aura-features { padding: 64px 0; }
  .features-grid { grid-template-columns: 1fr; }
  .features-header { margin-bottom: 40px; }
}
</style>
